import { createContext,useReducer, useEffect } from "react";
import { jwtDecode } from "jwt-decode";

export const AuthContext = createContext();

export const AuthReducer = (state,action) => {
    switch(action.type){
        case "LOGIN":
            return {user: action.payload}
        case "LOGOUT":
            return {user: null}
        default:
            return state;
        }
}

export const AuthContextProvider = ({children}) => {
    const [state,dispatch] = useReducer(AuthReducer,{
        user: null
    });

    useEffect(() => {
        try{
            const _user = JSON.parse(localStorage.getItem('user'));
                if(_user?.token){
                const decodedToken = jwtDecode(_user?.token.toString());

                const user = {
                    ...decodedToken,
                    token: _user.token
                }

                if ( _user && decodedToken.exp * 1000 > Date.now()) {
                    dispatch({type: 'LOGIN',payload: user});
                }else{
                    dispatch({type: 'LOGOUT',payload: user});
                    localStorage.removeItem('user');
                }
                
            }else{
                dispatch({type: 'LOGOUT',payload: _user});
            }
        }catch(err){
            dispatch({type: 'LOGOUT',payload: null});
            localStorage.removeItem('user');
        }
        
    },[]);

    return (
        <AuthContext.Provider value={{...state,dispatch}}>
            {children}
        </AuthContext.Provider>
    )
}